import { Link } from "react-router-dom";
import Logo from "./Logo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <Logo iconSize={20} textSize="text-xl" />
            <p className="text-muted-foreground text-sm">
              The Golden Touch for E-commerce. Transform your visual merchandising with AI.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-primary font-semibold mb-4">Product</h4>
            <ul className="space-y-2">
              <li><a href="#features" className="text-muted-foreground hover:text-primary transition-colors text-sm">Features</a></li>
              <li><Link to="/pricing" className="text-muted-foreground hover:text-primary transition-colors text-sm">Pricing</Link></li>
              <li><a href="#case-studies" className="text-muted-foreground hover:text-primary transition-colors text-sm">Case Studies</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-primary font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-muted-foreground hover:text-primary transition-colors text-sm">About Us</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors text-sm">Contact</Link></li>
              <li><Link to="/affiliate" className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">Agency Partner Program</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-primary font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors text-sm">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors text-sm">Terms of Service</Link></li>
              <li><Link to="/cookies" className="text-muted-foreground hover:text-primary transition-colors text-sm">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8 text-center space-y-1">
          <p className="text-muted-foreground text-sm">
            Echo Verse DB LLC — Orchestrating the Future of Digital Infrastructure.
          </p>
          <p className="text-muted-foreground text-sm">
            © {currentYear} MerchMidas. An Echo Verse DB LLC venture, Wyoming, USA.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

